<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="departments"
            v-model="filters.recommend_department_id"
            placeholder="Select Department"
            id="design2"
          />
          <label class="focus-label">Rec. Dept.</label>
        </div>
        <i
          v-if="filters.recommend_department_id"
          @click="handleClearOneFilter('recommend_department_id')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus text-truncate">
          <vue-select
            :options="designations"
            v-model="filters.recommend_designation_id"
            placeholder="Select Designation"
            id="design4"
          />
          <label class="focus-label">Rec. Desig.</label>
        </div>
        <i
          v-if="filters.recommend_designation_id"
          @click="handleClearOneFilter('recommend_designation_id')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="genders"
            v-model="filters.gender_id"
            placeholder="Select Gender"
          />
          <label class="focus-label">Gender</label>
        </div>
        <i
          v-if="filters.gender_id"
          @click="handleClearOneFilter('gender_id')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="locations"
            v-model="filters.apply_location"
            placeholder="Select Location"
          />
          <label class="focus-label">Location</label>
        </div>
        <i
          v-if="filters.apply_location"
          @click="handleClearOneFilter('apply_location')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="experiences"
            v-model="filters.experience"
            placeholder="Select Experience"
          />
          <label class="focus-label">Experience</label>
        </div>
        <i
          v-if="filters.experience"
          @click="handleClearOneFilter('experience')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedApplicantId }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.applicant_id"
            @focus="isFocusedApplicantId = true"
            @blur="isFocusedApplicantId = applicant_id !== ''"
          />
          <label class="focus-label">Applicant Id</label>
        </div>
      </div>

      <div class="col-md-9"></div>
      <div class="d-flex mb-2 col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import DepartmentService from "@/services/DepartmentService";
import GenderService from "@/services/GenderService";
import CityService from "@/services/CityService";
import ExperienceService from "@/services/ExperienceService";
import DesignationService from "@/services/DesignationService";

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters: {
        recommend_department_id: "",
        recommend_designation_id: "",
        gender_id: "",
        apply_location: "",
        experience: "",
        applicant_id: "",
      },
      isFocusedApplicantId: false,
      isFocusedOn: false,
      departments: [],
      genders: [],
      locations: [],
      experiences: [],
      designations: [],
      jobs: [],
      priorities: ["low", "medium", "high"],
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    // async fetchEmploymentStatuses() {
    //   try {
    //     const response = await DutyTypeService.fetch();
    //     this.employmentStatuses = response?.data.map((el) => el.duty_type);
    //   } catch (error) {
    //     console.error("Error fetching employment statuses:", error);
    //   }
    // },
    async fetchRecruiters() {
      try {
        const response = await DesignationService.getDesignations();
        this.designations = response?.data.map((el) => el.designation_name);
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    },
    async fetchGenders() {
      try {
        const response = await GenderService.getGenders();
        this.genders = response?.data.map((e) => e.gender_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchLocations() {
      try {
        const response = await CityService.getCities();
        this.locations = response?.data.map((e) => e.city_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchExperiences() {
      try {
        const response = await ExperienceService.fetch();
        this.experiences = response?.data.map((e) => e.experience);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },

    async fetchDepts() {
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = response?.data.map((el) => el.name);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        recommend_department_id: "",
        recommend_designation_id: "",
        gender_id: "",
        apply_location: "",
        experience: "",
        applicant_id: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        // this.fetchEmploymentStatuses();
        await this.fetchRecruiters();
        await this.fetchDepts();
        await this.fetchGenders();
        await this.fetchLocations();
        await this.fetchExperiences();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
    // this.campaigns = (await CampaignService.getCampaigns())?.data.map(
    //   (el) => el.campaigns
    // );
    // this.projects = (await EmployeeProjectService.fetch())?.data.map(
    //   (el) => el.project_name
    // );
    // this.sections = (await SectionService.getSections())?.data.map(
    //   (el) => el.section_name
    // );

    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));

    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
